// extracted by mini-css-extract-plugin
export var aircallIframe = "_i5-3";
export var fabContainer = "_i5-5";
export var fabRinging = "_i5-6";
export var loadingOverlay = "_i5-4";
export var pulse = "_i5-7";
export var widgetContent = "_i5-2";
export var widgetPanel = "_i5-0";
export var widgetPanelExpanded = "_i5-1";